import { getServiceProvider } from '@takeshape/service-providers';
import { avatars, logos } from '../assets/index.js';
import { createServiceProvider } from '../util/index.js';

export default createServiceProvider({
  ...getServiceProvider('contentful'),
  hasConnectionStatus: false,
  defaultAuthenticationType: 'bearer',
  avatarPath: avatars.contentful,
  logoPath: logos.contentful
});
